export default "__VITE_ASSET__d9fe1434__"